module.exports = __webpack_public_path__ + "img/ANYMARKET_BANNER.a6061589.png";